import Category from './Category';

const articleTypes: Category[] = [
  {
    name: 'Spotlight',
    slug: 'spotlight',
    id: '',
    taxonomy: 'article-type',
  },
  {
    name: 'Being Supportive',
    slug: 'being-supportive',
    id: '',
    taxonomy: 'article-type',
  },
  {
    name: 'Recipes',
    slug: 'recipe',
    id: '',
    taxonomy: 'article-type',
  },
];

export default articleTypes;
